import { createUrlMatcher } from "../url-matcher/factory.js";
import { UrlPatternType } from "../url-matcher/types.js";
export var Platform;
(function (Platform) {
    Platform[Platform["DEFAULT"] = 0] = "DEFAULT";
    Platform[Platform["ALEKS"] = 1] = "ALEKS";
    Platform[Platform["MCGRAW_HILL"] = 2] = "MCGRAW_HILL";
    Platform[Platform["PEARSON"] = 3] = "PEARSON";
    Platform[Platform["CENGAGE"] = 4] = "CENGAGE";
    Platform[Platform["WILEY"] = 5] = "WILEY";
    Platform[Platform["MY_OPEN_MATH"] = 6] = "MY_OPEN_MATH";
    Platform[Platform["WW_NORTON"] = 7] = "WW_NORTON";
    Platform[Platform["U_CERTIFY"] = 8] = "U_CERTIFY";
    Platform[Platform["WEBWORK"] = 9] = "WEBWORK";
    Platform[Platform["MACMILLAN"] = 10] = "MACMILLAN";
    Platform[Platform["LABYRINTH"] = 11] = "LABYRINTH";
    Platform[Platform["ZYBOOKS"] = 12] = "ZYBOOKS";
    Platform[Platform["VHL"] = 13] = "VHL";
    Platform[Platform["ATOMIC"] = 14] = "ATOMIC";
    Platform[Platform["WILLOLABS"] = 15] = "WILLOLABS";
    Platform[Platform["LUMINA"] = 16] = "LUMINA";
})(Platform || (Platform = {}));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PLATFORM_MATCHERS = {
    [Platform.MCGRAW_HILL]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://connect.router.integration.prod.mheducation.com/*/heclrReturn",
            },
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://connect.router.integration.prod.mheducation.com/*/coversheet",
            },
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://sso.router.integration.prod.mheducation.com/*/coversheet*",
            },
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://lms.mheducation.com/*/launch*",
            },
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://*.simnetonline.com/*/assignments/*",
            },
            { type: UrlPatternType.DOMAIN, domain: "mhcampus.com" },
        ],
    }),
    [Platform.PEARSON]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            { type: UrlPatternType.DOMAIN, domain: "pearson.com" },
            { type: UrlPatternType.DOMAIN, domain: "mypearson.com" },
        ],
    }),
    [Platform.ALEKS]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            { type: UrlPatternType.WILDCARD, pattern: "https://*.aleks.com/*#home" },
            { type: UrlPatternType.WILDCARD, pattern: "https://*.aleks.com/*#assignment*" },
            { type: UrlPatternType.DOMAIN, domain: "aleks.com" },
        ],
    }),
    [Platform.WILEY]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            {
                type: UrlPatternType.REGEX,
                regex: "https?://([\\w.-]+\\.)?wiley\\.com/.*assessment-player.*",
            },
        ],
    }),
    [Platform.CENGAGE]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            {
                type: UrlPatternType.REGEX,
                regex: "https?://([\\w.-]+\\.)?cengage\\.com/.*static.*",
            },
            { type: UrlPatternType.DOMAIN, domain: "cengage.com" },
        ],
    }),
    [Platform.MY_OPEN_MATH]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            {
                type: UrlPatternType.REGEX,
                regex: "https?://([\\w.-]+\\.)?myopenmath\\.com/assess2/.*",
            },
            { type: UrlPatternType.DOMAIN, domain: "myopenmath.com" },
        ],
    }),
    [Platform.WW_NORTON]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "wwnorton.com" }],
    }),
    [Platform.U_CERTIFY]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "ucertify.com" }],
    }),
    [Platform.WEBWORK]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://webwork.*.edu/webwork2/*",
            },
            {
                type: UrlPatternType.WILDCARD,
                pattern: "https://webwork-prod-app.*/webwork2/*",
            },
        ],
    }),
    [Platform.MACMILLAN]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "macmillanlearning.com" }],
    }),
    [Platform.LABYRINTH]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "labyrinthelab.com" }],
    }),
    [Platform.ZYBOOKS]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.HOSTNAME, hostname: "exams-learn.zybooks.com" }],
    }),
    [Platform.ATOMIC]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [
            { type: UrlPatternType.HOSTNAME, hostname: "atomicjoltapps.com" },
            { type: UrlPatternType.HOSTNAME, hostname: "atomicjolt.com" },
        ],
    }),
    [Platform.VHL]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "vhlcentral.com" }],
    }),
    [Platform.WILLOLABS]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "willolabs.com" }],
    }),
    // Deliberately the whole company domain, decided 2026-08-24 (CHANGES-REQUIRED.md CR-20). This claims
    // every yuja.com host as a Lumina quiz site, Verity's own included, and that is accepted: it removes
    // the three-store extension release a new Lumina apex would otherwise cost. What still bounds a saved
    // quizUrl is LUMINA_QUIZ_HOST_ALLOWLIST at save time (SPEC-3.md §8.2) — this matcher is now the wider
    // of the two by construction, so the disagreement check can no longer fire.
    //
    // This breadth is for identifying the platform, NOT for deciding whether a page is the quiz. That
    // decision moved to the saved quizUrl (`show-start-third-party-assessment-popup.tsx` ->
    // `content-scripts/helpers/lumina-quiz-url.ts`, CR-21): the extension holds one global assessment
    // slot, so matching every yuja.com host meant the first such page to load after the student connects
    // claimed it and the quiz page was then refused with `already-started`.
    //
    // HOSTNAME_SUFFIX, still never DOMAIN, WILDCARD or REGEX: the first two would behave the same here,
    // but WILDCARD and REGEX match the whole URL string and would accept
    // `https://evil.com/?x=.yuja.com/`. Suffix matching parses the hostname, so `yuja.com.evil.test` and
    // `notyuja.com` are still rejected.
    [Platform.LUMINA]: createUrlMatcher({
        type: UrlPatternType.COMPOSITE,
        urlPatterns: [{ type: UrlPatternType.HOSTNAME_SUFFIX, hostnameSuffix: "yuja.com" }],
    }),
};
export function getPlatformIdFromUrl(url) {
    if (url === null)
        return null;
    for (const [platformKey, matcher] of Object.entries(PLATFORM_MATCHERS)) {
        const platform = Number(platformKey);
        if (matcher.match(url)) {
            return platform;
        }
    }
    return null;
}
//# sourceMappingURL=third-party-matchers.js.map